<div class="customization-border" *ngIf="isCustomizationSelected">
	<h2 class="customization-att-title">Review Your Customization</h2>
	<button class="edit-customization" (click)="openEditCustomPanel()">
		<span class="hmf-p-0">Edit Customizations</span>
	</button>
	<ul class="customization-element">
		<li *ngFor="let dataElement of customizedAttributes; trackBy: trackByFn;">
			<homefield-icon
				width="14px"
				height="14px"
				name="sign-circled-check-outline"
				fill="var(--hmf-scgreen)">
			</homefield-icon>
			<span class="custom-attr-name">{{dataElement.name}}</span>: &nbsp;{{dataElement.value}}
		</li>
	</ul>
</div>
